export const environment = {
  name: 'production',
  production: true,
  server_url_base: 'https://app.retailx.net/ssr-shared/',
  server_port: 4202,

  backend_base: 'https://app.retailx.net/api/',
  frontend_base: 'https://app.retailx.net/',

  raa: {
    frontend_base: 'https://myaccount.retailx.net/',
  },

  mra: {
    frontend_base: 'http://ec2-52-17-225-205.eu-west-1.compute.amazonaws.com/',
  },

  wp: {
    frontend_base: 'https://intelligence.retailx.net/',
    sign_up_url: 'https://intelligence.retailx.net/sign-up/#Subscriptions',
  },

  retailx_base: 'https://retailx.net/',
};
